import * as communicatorActions from './actions';
import communicatorReducer from './reducer';
import * as communicatorTypes from './types';

export {communicatorActions, communicatorTypes};

export default communicatorReducer;
